<div>
  <idt-common-styles-render
    *ngIf="piece">
  </idt-common-styles-render>
</div>
